class StoreMapRegion {
  /**
   * API may send `points` as a JSON string; map/form code needs number[][].
   */
  static parsePointsArray (value) {
    if (value == null || value === '') return null
    if (Array.isArray(value)) return value
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value)
        return Array.isArray(parsed) ? parsed : null
      } catch {
        return null
      }
    }
    return null
  }

  constructor (
    id = undefined,
    name,
    points,
    active,
    createdAt,
    userId = null,
    ownerRoleId = null
  ) {
    this.id = id
    this.name = name
    this.points = points
    this.active = active
    this.createdAt = new Date(createdAt)
    this.userId = userId ?? null
    this.ownerRoleId = ownerRoleId ?? null
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      name: this.name,
      points: this.points && JSON.stringify(this.points),
      active: this.active
      // createdAt / userId are read-only from client forms unless API accepts them
    })
  }

  static FromNormalizedRESTModel ({
    id,
    name,
    points,
    active,
    enabled,
    createdAt,
    userId,
    ownerRoleId
  }) {
    return new StoreMapRegion(
      id,
      name,
      StoreMapRegion.parsePointsArray(points),
      active ?? enabled,
      createdAt,
      userId,
      ownerRoleId
    )
  }

  toJSON () {
    return {
      id: this.id,
      name: this.name,
      points: this.points,
      active: this.active,
      createdAt: this.createdAt,
      userId: this.userId,
      ownerRoleId: this.ownerRoleId
    }
  }

  static FromJSON ({
    id,
    name,
    points,
    active,
    enabled,
    createdAt,
    userId,
    ownerRoleId
  }) {
    return new StoreMapRegion(
      id,
      name,
      StoreMapRegion.parsePointsArray(points),
      active ?? enabled,
      createdAt,
      userId,
      ownerRoleId
    )
  }
}

export default StoreMapRegion
